import React from "react";

const CouponStats = ({ stats }) => {

    const cards = [
        {
            title: "Total Coupons",
            value: stats.totalCoupons || 0,
        },
        {
            title: "Active",
            value: stats.activeCoupons || 0,
        },
        {
            title: "Inactive",
            value: stats.inactiveCoupons || 0,
        },
        {
            title: "Expired",
            value: stats.expiredCoupons || 0,
        },
        {
            title: "Scheduled",
            value: stats.scheduledCoupons || 0,
        },
        {
            title: "Total Usage",
            value: stats.totalUsage || 0,
        },
    ];

    return (
        <div className="coupon-stats">

            {cards.map((card, index) => (
                <div
                    key={index}
                    className="coupon-stat-card"
                >
                    <h3>{card.value}</h3>
                    <p>{card.title}</p>
                </div>
            ))}

        </div>
    );
};

export default CouponStats;